document.addEventListener('DOMContentLoaded', function() {
    const targetNodeDesktop = document.querySelector('#FacetsWrapperDesktop');
    const targetNodeMobile = document.querySelector('#FacetsWrapperMobile');
    const observerOptions = {
        childList: true,
        attributes: true,
        subtree: true
    };

    const observerCallback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                let hideLabel = document.querySelector('.button-label.hide-filter');
                let showLabel = document.querySelector('.button-label.open-filter');
                const facetsWrapper = document.querySelector('aside.facets-wrapper');
    
                if (facetsWrapper.classList.contains('show')) {
                    if (hideLabel) {
                        hideLabel.classList.add('show');
                    }
                    if (showLabel) {
                        showLabel.classList.remove('show');
                    }
                } else {
                    if (hideLabel) {
                        hideLabel.classList.remove('show');
                    }
                    if (showLabel) {
                        showLabel.classList.add('show');
                    }
                }
                
                hideLabel = document.querySelector('.button-label.hide-filter.show');
                if (hideLabel) {
                    hideLabel.addEventListener('click', function() {
                        hideLabel.classList.remove('show');
                        if (showLabel) {
                            showLabel.classList.add('show');
                        }
                    });
                }
    
                updateToggleButton();
                checkFacetsWrapperVisibility();
            }
        }
    };
    

    const observer = new MutationObserver(observerCallback);

    // Check desktop
    if (targetNodeDesktop) {
        observer.observe(targetNodeDesktop, observerOptions);
    }

    // Check mobile
    if (targetNodeMobile) {
        observer.observe(targetNodeMobile, observerOptions);
    }

    const toggleButton = document.querySelector('.mobile-facets__open-wrapper');
    const hideLabel = document.querySelector('.button-label.hide-filter');
    const showLabel = document.querySelector('.button-label.open-filter');
    const facetsWrapper = document.querySelector('aside.facets-wrapper');
    const filterIcon = document.querySelector('.mobile-facets__open svg');
    
    function initializeGridState() {
        const isFilterOpen = facetsWrapper.classList.contains('show');
        const productGrid = document.querySelector('#product-grid');
        
        if (isFilterOpen) {
            hideLabel.classList.add('show');
            showLabel.classList.remove('show');
            
            if (productGrid) {
                productGrid.classList.remove('filters-closed');
                productGrid.classList.add('filters-open');
            }
        } else {
            hideLabel.classList.remove('show');
            showLabel.classList.add('show');
            
            if (productGrid) {
                productGrid.classList.remove('filters-open');
                productGrid.classList.add('filters-closed');
            }
        }
    }
    setTimeout(initializeGridState, 100);
    
    toggleButton.addEventListener('click', function () {
        const isVisible = facetsWrapper.classList.toggle('show'); // Alternar a visibilidade do aside
        const productGrid = document.querySelector('#product-grid');
        
        if (isVisible) {
            // Mostrar o estado "Hide filters"
            hideLabel.classList.add('show');
            showLabel.classList.remove('show');
            
            // Aplicar classe para grid de 4 colunas (filtros abertos)
            if (productGrid) {
                productGrid.classList.remove('filters-closed');
                productGrid.classList.add('filters-open');
            }
        } else {
            // Mostrar o estado "Show filters"
            hideLabel.classList.remove('show');
            showLabel.classList.add('show');
            
            // Aplicar classe para grid de 5 colunas (filtros fechados)
            if (productGrid) {
                productGrid.classList.remove('filters-open');
                productGrid.classList.add('filters-closed');
            }
        }
    });
    

    function updateToggleButton() {
        const isVisible = facetsWrapper.classList.contains('show');
        const productGrid = document.querySelector('#product-grid');
        
        if (isVisible) {
            hideLabel.classList.add('show');
            showLabel.classList.remove('show');
            
            // Aplicar classe para grid de 4 colunas (filtros abertos)
            if (productGrid) {
                productGrid.classList.remove('filters-closed');
                productGrid.classList.add('filters-open');
            }
        } else {
            hideLabel.classList.remove('show');
            showLabel.classList.add('show');
            
            // Aplicar classe para grid de 5 colunas (filtros fechados)
            if (productGrid) {
                productGrid.classList.remove('filters-open');
                productGrid.classList.add('filters-closed');
            }
        }
    }

    // Adicionar listener para redimensionamento da janela
    window.addEventListener('resize', function() {
        updateToggleButton();
    });
    
    function checkFacetsWrapperVisibility() {
        // Determinar se é mobile ou desktop
        const isMobile = window.innerWidth < 979;
        
        // Verificar se os sliders existem antes de continuar
        const sliderContainers = document.querySelectorAll(isMobile ? '.mobile-slider' : '.desktop-slider');
        if (sliderContainers.length === 0) {
            return;
        }
        
        // Selecionar sliders e elementos de valor baseado na tela
        const minSliders = document.querySelectorAll(isMobile ? '.mobile-slider .price-slider-min' : '.desktop-slider .price-slider-min');
        const maxSliders = document.querySelectorAll(isMobile ? '.mobile-slider .price-slider-max' : '.desktop-slider .price-slider-max');
        const minValueDisplays = document.querySelectorAll(isMobile ? '.mobile-slider .price-value-min' : '.desktop-slider .price-value-min');
        const maxValueDisplays = document.querySelectorAll(isMobile ? '.mobile-slider .price-value-max' : '.desktop-slider .price-value-max');

        function formatToDecimal(value) {
            return (parseFloat(value) / 100).toFixed(2);
        }

        function formatCurrency(value) {
            return parseFloat(value).toFixed(2);
        }

        // Adicionar event listeners para cada slider mínimo
        minSliders.forEach((minSlider, index) => {
            // Verificar se já tem event listener (usando data attribute)
            if (minSlider.dataset.listenerAttached === 'true') {
                return;
            }
            
            const maxSlider = maxSliders[index];
            const minValueDisplay = minValueDisplays[index];
            const maxValueDisplay = maxValueDisplays[index];
            const inputId = minSlider.getAttribute('data-input-id');
            const minPriceInput = document.getElementById(inputId);
            const maxInputId = maxSlider.getAttribute('data-input-id');
            const maxPriceInput = document.getElementById(maxInputId);

            // Inicializar valores exibidos
            const currentMinValue = formatToDecimal(minSlider.value);
            const currentMaxValue = formatToDecimal(maxSlider.value);
            if (minValueDisplay) minValueDisplay.textContent = `$ ${currentMinValue}`;
            if (maxValueDisplay) maxValueDisplay.textContent = `$ ${currentMaxValue}`;

            // Marcar como inicializado
            minSlider.dataset.listenerAttached = 'true';
            maxSlider.dataset.listenerAttached = 'true';

            minSlider.addEventListener('input', () => {
                const minVal = parseInt(minSlider.value);
                const maxVal = parseInt(maxSlider.value);
                
                if (minVal > maxVal) {
                    minSlider.value = maxVal;
                }
                
                const formattedMinValue = formatToDecimal(minSlider.value);
                if (minValueDisplay) {
                    minValueDisplay.textContent = `$ ${formattedMinValue}`;
                }
                if (minPriceInput) {
                    minPriceInput.value = formattedMinValue;
                    // Disparar evento change para atualizar o filtro
                    minPriceInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });

            maxSlider.addEventListener('input', () => {
                const minVal = parseInt(minSlider.value);
                const maxVal = parseInt(maxSlider.value);
                
                if (maxVal < minVal) {
                    maxSlider.value = minVal;
                }
                
                const formattedMaxValue = formatToDecimal(maxSlider.value);
                if (maxValueDisplay) {
                    maxValueDisplay.textContent = `$ ${formattedMaxValue}`;
                }
                if (maxPriceInput) {
                    maxPriceInput.value = formattedMaxValue;
                    // Disparar evento change para atualizar o filtro
                    maxPriceInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });

        // Sincronizar inputs numéricos com sliders
        const priceInputs = document.querySelectorAll('price-range input[type="number"]');
        priceInputs.forEach(input => {
            // Verificar se já tem event listener
            if (input.dataset.listenerAttached === 'true') {
                return;
            }
            
            input.dataset.listenerAttached = 'true';
            
            input.addEventListener('input', () => {
                const sliderContainer = input.closest('price-range').previousElementSibling;
                if (!sliderContainer || !sliderContainer.classList.contains('slider-container')) return;
                
                const minSlider = sliderContainer.querySelector('.price-slider-min');
                const maxSlider = sliderContainer.querySelector('.price-slider-max');
                const minValueDisplay = sliderContainer.querySelector('.price-value-min');
                const maxValueDisplay = sliderContainer.querySelector('.price-value-max');
                
                if (input.id.includes('GTE') && minSlider) {
                    const valueInCents = Math.round(parseFloat(input.value || 0) * 100);
                    minSlider.value = valueInCents;
                    if (minValueDisplay) {
                        minValueDisplay.textContent = `$ ${formatCurrency(input.value || 0)}`;
                    }
                } else if (input.id.includes('LTE') && maxSlider) {
                    const valueInCents = Math.round(parseFloat(input.value || 0) * 100);
                    maxSlider.value = valueInCents;
                    if (maxValueDisplay) {
                        maxValueDisplay.textContent = `$ ${formatCurrency(input.value || 0)}`;
                    }
                }
            });
        });
    }

    // Inicializar na carga da página
    setTimeout(() => {
        checkFacetsWrapperVisibility();
    }, 100);

    // Resize
    window.addEventListener('resize', () => {
        setTimeout(() => {
            checkFacetsWrapperVisibility();
        }, 100);
    });


    //close mobile filter
    const closeMobileFilter = document.querySelector('.close-filter-mob');
    if (closeMobileFilter) {
        closeMobileFilter.addEventListener('click', function() {
            const disclosure = document.querySelector('.mobile-facets__disclosure');
            if (disclosure) {
                disclosure.classList.remove('menu-opening');
                disclosure.removeAttribute('open');
            }
            const body = document.querySelector('body');
            if (body) {
                body.classList.remove('overflow-hidden-mobile');
            }
        });
    }

});
